<template>
  <div class="footer">

    <v-footer color="#848386">
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="auto" class="pr-12 footer-first-column">
            <v-img src="@/assets/img/cs-logo-1-blanco.svg" class="footer-logo-artless" max-width="150px"></v-img>
          </v-col>
          <v-col cols="4" md="auto" class="pr-12">
            <div>
              <router-link to="/about" class="not-text-decoration footer-links ">
                <span class="white--text gtAmerica-extended">About</span>
              </router-link>
            </div>
            <div>
              <router-link to="/manifesto" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Manifesto</span>
              </router-link>
            </div>
            <div>
              <router-link to="/materials" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Materials</span>
              </router-link>
            </div>
            <div>
              <router-link to="/mosaic" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Mosaic</span>
              </router-link>
            </div>
          </v-col>
          <v-col cols="4" md="auto" class="pr-12">
              <div>
                <router-link to="/terms" class="not-text-decoration footer-links">
                  <span class="white--text gtAmerica-extended">Terms of Service</span>
                </router-link>
              </div>
              <div>
                <router-link to="/faq" class="not-text-decoration footer-links">
                  <span class="white--text gtAmerica-extended">FAQ</span>
                </router-link>
              </div>
          </v-col>
          <v-col cols="4" md="auto">
            <div>
              <router-link to="/contact" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Contact</span>
              </router-link>
            </div>
            <div>
              <a href="https://www.instagram.com/artlesscorporation/" class="not-text-decoration footer-links" target="_blank">
                <span class="white--text gtAmerica-extended">Instagram</span>
              </a>
            </div>
          </v-col>
          <v-col class="py-0 footer-last-column">
            <div class="text-right">
              <span class="white--text d-block newsletter-title">NEWSLETTER</span>
            </div>
            <v-row class="margin-custom-textfield" justify="end">
              <v-col cols="auto" class="py-0">
                <v-text-field
                  v-model="emailNewsLetter"
                  label="ENTER YOUR EMAIL"
                  outlined
                  flat
                  background-color="#848386"
                  dark
                  :placeholder="newsletter.newsletterText"
                  elevation="0"
                  hide-details
                ></v-text-field>
                <div class="text-right py-4">
                  <span class="white--text copyright-leg">©️ 2008-2020 ARTLESS CORPORATION. ALL RIGHTS RESERVED.</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {
    menu: { type: Number, required: true },
  },
  data() {
    return {
      emailNewsLetter: "",
      newsletter: {
        newsletterText: ''
      },
      links: [
        {
          rutas1: [
            {
              url: "/furniture",
              text: "Furniture",
            },
            {
              url: "/custom",
              text: "Custom",
            },
            {
              url: "/shop",
              text: "Shop",
            },
          ],
          rutas2: [
            {
              url: "/materials",
              text: "Materials",
            },
            {
              url: "/about",
              text: "About",
            },
            {
              url: "/contact",
              text: "Contact",
            },
          ],
          rutas3: [
            {
              url: "https://www.instagram.com",
              text: "Instagram",
            },
            {
              url: "/terms",
              text: "Terms of services",
            },
            {
              url: "/faq",
              text: "FAQ",
            },
          ],
        },
      ],
    };
  },
  beforeMount: function(){
    fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/Newsletter?token=a15be93e9cdb43ca2b3778c2077c26')
    .then(data => data.json())
    .then(data => this.newsletter = data);
  }
};
</script>